import Redirect from 'App/Helpers/Redirect';
import { errorList } from 'App/Helpers/validations/ErrorsList';

export function getErrorMessage(errorCode, message, defaultUrl, lang) {
    const list = errorList(defaultUrl, lang);

    if (typeof list[errorCode].errorMessage === 'function') {
        return list[errorCode].errorMessage(message);
    }

    return list[errorCode].errorMessage;
}

export function shouldRedirect(errorCode, defaultUrl, lang) {
    const list = errorList(defaultUrl, lang);

    return {
        redirect: list[errorCode].redirect,
        location: list[errorCode].redirectType,
    };
}

export function handleRedirect({ error, fallbackUrl, lang, env }) {
    const { message, code } = error;

    const { redirect, location } = shouldRedirect(code, fallbackUrl, lang);

    if (error === 'undefined' || code === 'undefined') {
        Redirect.redirect(location, env);
    }

    if (redirect) {
        Redirect.redirect(location, env);
    } else {
        const errorMessage = getErrorMessage(code, message, fallbackUrl, lang);

        throw new Error(errorMessage);
    }
}
